import { useCurrentUser } from '@hooks';
import { useNavigate } from 'react-router-dom';
import React, { PropsWithChildren } from 'react';

export interface FullUserBoundaryProps{
	redirect?: string
}

export const FullUserBoundary: React.FC<PropsWithChildren<FullUserBoundaryProps>> = ({ redirect, children }) => {
	const { isReadOnly } = useCurrentUser();
	const navigate = useNavigate();

	if (isReadOnly) {
		if (!redirect) {
			return null;
		}

		navigate(redirect);
	}

	return children as React.ReactElement;
};
